import React from "react";

function AwardsList() {
  return (
    <div className="mt-10 px-4 sm:px-6 lg:px-8 text-center">
      <h1 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
        Honors & Awards
      </h1>

      <section className="mt-12 space-y-8 text-left text-gray-300">
        <div>
          <h3 className="text-xl font-medium text-white">
            Inaugural Defense & Security Research Symposium, PMRI (2025)
          </h3>
          <p>
            Presented a novel SRIM/TRIM-based testing framework for qualifying
            commercial microelectronics (FTLX8574D3BCV multimode 10G SFP+
            optical transceiver) for space applications.{" "}
            {/* <a href="/experience" className="text-teal-500 hover:underline">
              See more here
            </a> */}
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium text-white">SmithAI Project (2025)</h3>
          <p>
            Built an AI platform in 36 hours that deploys AI-powered agents with
            HTML, JavaScript, Tailwind, Flask, CSS, AWS, and MongoDB on the back
            end. Recognized with awards including Best Use of Generative AI
            (MLH) and Best Cloud Implementation (Caterpillar), and Most Likely
            to Be Business (Purdue Innovates).
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium text-white">
            Final Design Review (2024)
          </h3>
          <p>
            One of 318 students chosen to present a prototype of an insect
            nanolab at NASA’s Final Design Review in Houston, showcasing an
            innovative solution for sustainable food sources aboard the ISS.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium text-white">
            Widener Leadership Awards (2023)
          </h3>
          <p>
            One of 129 students selected across Pennsylvania, New Jersey, and
            Delaware for exceptional leadership in school and community
            activities, recognized by Widener University in partnership with
            NBC10.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium text-white">
            Jewish Exponent Article (2023)
          </h3>
          <p>
            Interviewed for & quoted in the Jewish Exponent for an article on
            the revival of Sigma Alpha Rho.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium text-white">Scholarships</h3>
          <p>
            Received Summer Scholar Scholarship (2025); Sigma Phi Epsilon
            Balanced Man Scholarship (2024); Sigma Alpha Rho Rathblott
            Scholarship (2024); Zeta Beta Tau Freshman of Excellence Scholarship
            (2024); First Time Researcher Fellowship (2024).
          </p>
        </div>
      </section>
    </div>
  );
}

export default AwardsList;
